import Vue from 'vue'

/**
 * @Description 默认图片
 * @author XuZiYu
 * @date 2022/09/01 11:20:59
*/
Vue.directive('real-img', async function (el, binding) {
    let imgURL = binding.value;//获取图片地址
    let defaultURL = require('@/assert/default-img.png')
    let imageExist = (url)=>{
        return new Promise((resolve) => {
            let img = new Image();
            img.onload = function () {
                if (this.complete === true){
                    resolve(true);
                    img = null;
                }
            }
            img.onerror = function () {
                resolve(false);
                img = null;
            }
            img.src = url;
        })
    }
    if (imgURL) {
        let exist = await imageExist(imgURL);
        if (exist) {
            el.setAttribute('src', imgURL);
        } else {
            if (defaultURL) {
                el.setAttribute('src', defaultURL);
            }
        }
    }
})
